import { render } from "./AddressInfo.vue?vue&type=template&id=8c1402ea&ts=true"
import script from "./AddressInfo.vue?vue&type=script&lang=ts"
export * from "./AddressInfo.vue?vue&type=script&lang=ts"

import "./AddressInfo.vue?vue&type=style&index=0&id=8c1402ea&lang=css"

import exportComponent from "/builds/t2_w86CdT/0/sfs-projects/development/station-handler-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__